module.exports = __webpack_public_path__ + "img/32.58f91cf.jpg";